import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Select Your Pack",
    description:
      "The Throwback Pack provides a significant discount off single game prices and you will receive a complimentary throwback jersey keychain for each pack purchased!",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Click Continue and connect to your Jacksonville Jaguars account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description:
      "Select the seats you wish to purchase for the games. The same number of seats will be applied to each game in the pack.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description:
      "Tickets will be available in your Jacksonville Jaguars Account Manager. Reach out to Live Fan Support for any questions.",
  },
];

export const faqs = [
  {
    title: "How does the Throwback Pack work?",
    description: (
      <>
        The Throwback Pack gives fans access to the four games in 2025 when the
        Jaguars take the field in their throwback uniforms! The games included
        are against the Houston Texans, Kansas City Chiefs, Indianapolis Colts,
        and Tennessee Titans. Purchase also includes a free{" "}
        <b>Jaguars Throwback Keychain</b>! To purchase, simply log into your
        Jacksonville Jaguars Account Manager and select your seats.
      </>
    ),
  },
  {
    title: "Do I have to select all my games now?",
    description:
      "Yes - all 4 games will automatically be added to your cart when you select the Throwback Pack.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description:
      "Yes, you can choose from all currently available inventory. The same number of seats for every game will automatically be applied.",
  },
  {
    title: "Where are my tickets delivered?",
    description: (
      <>
        Tickets will be delivered directly within your Jacksonville Jaguars{" "}
        <Link href="https://am.ticketmaster.com/jaguars/">Account Manager</Link>
        .
      </>
    ),
  },
];

export const JaguarsRegistrationTerms = () => (
  <>
    By creating an account you agree to receive email notifications regarding
    your purchase and to the{" "}
    <Link
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      target={"_blank"}
      href="https://www.attend.tech/terms-of-use"
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>
    .
  </>
);

export const JaguarsCheckoutTerms = () => (
  <>
    By purchasing you agree to receive SMS alerts regarding ticket delivery and
    agree to the{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/terms-of-use"
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>
    .
  </>
);
